<template>
  <security-mask/>
  <el-form>
    <el-form-item label="test1">
      <el-input></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
import SecurityMask from "./SecurityMask";

export default {
  name: "SecurityMaskTest",
  components: {SecurityMask}
}
</script>

<style scoped>

</style>